import { EventData } from '../../WorkflowEngine/workflowEngineReducer';

export const decodeTextWithEventData = (source: string, data: EventData) => {
  let convertedText = source;
  Object.getOwnPropertyNames(data).forEach((propName: string) => {
    const propNamePascalCase = `${propName
      .charAt(0)
      .toUpperCase()}${propName.slice(1)}`;

    let valueToReplace = data[propName]?.toString().trim() || 'Not Available';

    const isDate = /^\d{4}-\d{2}-\d{2}/.test(valueToReplace.toString());

    if (isDate) {
      valueToReplace = new Date(valueToReplace).toLocaleDateString();
    }

    convertedText = convertedText.replace(
      `{${propNamePascalCase}}`,
      valueToReplace
    );
  });
  return convertedText;
};
